var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50663 1.71436C14.2343 1.71436 18.0676 5.54674 18.0676 10.2753C18.0676 15.0039 14.2343 18.8363 9.50663 18.8363C4.77806 18.8363 0.945679 15.0039 0.945679 10.2753C0.945679 5.54674 4.77806 1.71436 9.50663 1.71436Z",
    stroke: "#ff4e00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1302 17.4878C18.9092 17.4878 19.5407 18.1202 19.5407 18.8983C19.5407 19.6783 18.9092 20.3097 18.1302 20.3097C17.3511 20.3097 16.7188 19.6783 16.7188 18.8983C16.7188 18.1202 17.3511 17.4878 18.1302 17.4878Z",
    stroke: "#ff4e00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchActive);
export default __webpack_public_path__ + "static/media/search_active.eba95eb73495f25e559c883cd25458e0.svg";
export { ForwardRef as ReactComponent };